// src/components/inputs/MultiImageUploader/UploadedImageCard.jsx

import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { Delete, CheckCircle } from "@mui/icons-material";

const UploadedImageCard = ({
    image,
    index,
    isArabic,
    isDark,
    onDelete,
}) => {
    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                height: 180,
                borderRadius: 2,
                overflow: 'hidden',
                backgroundColor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
            }}
        >
            <img
                src={image.preview || image.url || image.thumb_url}
                alt={`Upload ${index + 1}`}
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                }}
            />

            {/* Delete button */}
            <Tooltip title={isArabic ? 'حذف' : 'Delete'}>
                <IconButton
                    size="small"
                    color="error"
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        backgroundColor: 'rgba(0,0,0,0.6)',
                        '&:hover': {
                            backgroundColor: 'rgba(0,0,0,0.8)',
                        },
                    }}
                    onClick={onDelete}
                >
                    <Delete fontSize="small" sx={{ color: 'white' }} />
                </IconButton>
            </Tooltip>

            {/* Success indicator */}
            <CheckCircle
                sx={{
                    position: 'absolute',
                    bottom: 8,
                    left: 8,
                    color: 'success.main',
                    fontSize: 24,
                }}
            />
        </Box>
    );
};

export default UploadedImageCard;
